import * as microsoftTeams from '@microsoft/teams-js';

export const initTeams = () => {
  return new Promise<void>((resolve, reject) => {
    microsoftTeams.app
      .initialize()
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};
